<template>
  <v-card elevation="0" color="transparent">
    <v-row class="ma-3" :class="{'light-blue lighten-5': loginUserFormFlag}">
      <v-col>
        <h3>Login details
          <v-btn small color="primary" icon @click="loginUserFormFlag = !loginUserFormFlag">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </h3>
        <v-simple-table class="mb-5">
          <tbody>
          <tr>
            <td>Email</td>
            <td>{{userData.email}}</td>
          </tr>
          <tr>
            <td>Password</td>
            <td>*********</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
      <v-col>
        <template v-if="loginUserFormFlag">
          <h3>Edit login details</h3>
          <login-user-form class="mt-6" :user-data="userData" @cancel="loginUserFormFlag = false"></login-user-form>
        </template>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import LoginUserForm from "../Forms/loginUserForm";
  export default {
    name: "editLoginCredentials",
    components: {LoginUserForm},
    props: ['userData'],
    data: () => ({

      loginUserFormFlag: false,

    }),
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sections/editLoginCredentials.vue